import { Component, OnInit, ViewEncapsulation, Input, HostListener, SecurityContext } from '@angular/core';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { EnrollmentAppStateStructure } from '../../interfaces/enrollmentAppStateStructure.interface';
import { environment } from 'src/environments/environment';
import { DateService } from 'src/app/shared/services/date.service';
import { StateStructure } from '@ptl/state';
import { NgRedux } from '@ptl/angular-redux-store';
import { saveApplicationSubmissionInfo } from '../../../../shared/reducers/enrollmentApp.reducer';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
import { PlansStateStructure } from 'src/app/angular-elements/plan-selection/configs/interfaces/plansStateStructure.interface';
import { PRODUCT_GROUPS } from 'src/app/angular-elements/plan-selection/enums/product-groups.enum';
import { AuthoringModeService } from 'src/app/shared/services/authoring-mode.service';
import { ZipCountyStateStructure } from 'src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface';
import { IndividualMarketsEnrollmentSubmissionService } from '../../services/enrollment/individual-markets/enrollment-submission.individual-markets.service';
import { BrandingConfigurationService } from '@ptl/brand';
import { EntitlementsHelperService, LINE_OF_BUSINESS_ENUM } from '@ptl/account-management';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { APP_STATE_AS_CONTENT_ENUM } from 'src/app/angular-elements/shared/components/app-state-as-content/enums/app-state-as-content.enum';
import { CurrencyPipe } from '@angular/common';
import { FormNumberService } from 'src/app/angular-elements/shared/components/form-number/services/form-number.service';
import { EntityManagerService } from 'src/app/angular-elements/plan-selection/configs/rating-entities/entity-manager.service';
import { EBillTransferResponseInterface } from 'src/app/shared/interfaces/eBill/transfer.response.interface';

import { GlobalShadowStyleDirective } from '@ptl/global-components';
import { PRINT_TYPE } from '../print-button/enums/print-type.enum';
import { IndividualMarketStateStructure } from 'src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/interfaces/individualMarket.interfaceStateStructure';

enum PRINT_SCENARIO {
  SPECIAL_ENROLLMENT = "special-enrollment",
  ENHANCED_PRINT_PDF = "enhanced-pdf-print"
}
enum ALTERNATE_PRINT_SCENARIO {
  DOMESTIC_PARTNER_ATTESTATION = "domestic-partner-attestation-pdf"
}
enum ENROLLMENT_TYPE {
  OPEN_ENROLLMENT = "OPEN_ENROLLMENT",
  SPECIAL_ENROLLMENT_ONLINE = "SPECIAL_ENROLLMENT_ONLINE",
  SPECIAL_ENROLLMENT_PAPER = "SPECIAL_ENROLLMENT_PAPER",
  DENTAL_ENROLLMENT = "DENTAL_ENROLLMENT",
  BLUE_EDGE_DENTAL_ENROLLMENT = "BLUE_EDGE_DENTAL_ENROLLMENT"
}
@Component({
    selector: 'app-confirmation-page',
    templateUrl: './confirmation-page.component.html',
    styleUrls: ['./confirmation-page.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class ConfirmationPageComponent extends GlobalShadowStyleDirective implements OnInit {
  
  @Input() nextPageUrl: string;
  @Input() bannerColor: string = '#FEF0EC';
  @Input() noEnrollmentDataUrl: string = "./home";
  @Input() beginAppPage: string = null;
  @Input() lineOfBusiness: LINE_OF_BUSINESS_ENUM;
  @Input() printButtonExperienceType: PRINT_SCENARIO | null;
  @Input() showSecondPrint: boolean;
  @Input() altOnePrintExperience: ALTERNATE_PRINT_SCENARIO;
  @Input() isSpecialEnrollment: 'true' | 'false';
  @Input() enrollmentType: ENROLLMENT_TYPE;

  PRINT_TYPES = {
    APPLICATION_FORM: PRINT_TYPE.APPLICATION_FORM,
    DOMESTIC_PARTNER_ATTESTATION: PRINT_TYPE.DOMESTIC_PARTNER_ATTESTATION
  };
  
  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private dateUtility: DateService,
    private ngRedux: NgRedux<StateStructure>,
    private authoringMode: AuthoringModeService,
    private commonUtilityService: CommonUtilityService,
    private enrollSubmitIndividual: IndividualMarketsEnrollmentSubmissionService,
    private brandService: BrandingConfigurationService,
    private snackBar: MatSnackBar,
    private entitlementsHelperService: EntitlementsHelperService,
    private httpClient: HTTPWrapperContext,
    private sanitizer: DomSanitizer,
    private currencyPipe: CurrencyPipe,
    private formNumberService: FormNumberService,
    private entityManagerService: EntityManagerService
  ) { 
    super();
  }

  confirmationAppId: string;
  currentDate: string;
  angularHostUrl: string;
  planName: string;
  ratingEntity: string;
  effectiveDate: string;
  isAuthoring: boolean;
  submittedApplicantName: string;
  isIndividual: boolean;
  showPayPremium: boolean = false;
  planPremium: number | string;
  payload: any;
  brandDescription: string;
  indPersonalInfoBackup: any;
  eAppBackup: any;
  
  suppressBrandDescription: boolean; // Hopefully a temporary result of us hard-coding and needed these descriptions to vary

  @HostListener('window:beforeunload', ['$event'])
  ifLeavingPage(event) {
    if (event) {
      sessionStorage.removeItem('applicationForm');

      // TODO: Move this to indexdb storage backup logic/fallback as necessary if indexbdb n/a.

      this.ngRedux.dispatch(saveApplicationSubmissionInfo({} as EnrollmentAppStateStructure));
    }
  }

  ngOnInit() {
    
    this.isIndividual = false;
    this.isAuthoring = this.authoringMode.getAuthoringMode();
    let curBrand = this.brandService.getCurrentBrand();
    this.brandDescription = curBrand.description;

    /** Drives a suppression of a single phrase in the HTML - if we end up making this not hardcoded, we could drop this */
    this.suppressBrandDescription = (() => {
      switch (this.enrollmentType) {
        case ENROLLMENT_TYPE.BLUE_EDGE_DENTAL_ENROLLMENT:
        case ENROLLMENT_TYPE.DENTAL_ENROLLMENT:
          if (curBrand.state === "NY") {
            return false;
          } else {
            return true;
          }
          break;
        case ENROLLMENT_TYPE.OPEN_ENROLLMENT:
        case ENROLLMENT_TYPE.SPECIAL_ENROLLMENT_ONLINE:
        case ENROLLMENT_TYPE.SPECIAL_ENROLLMENT_PAPER:
        default:
          return false;
      }
    })();

    this.setDisplayData();

    this.commonUtilityService.resetStateExceptUserData();
    this.currentDate = this.dateUtility.getTodayAsMoment().toISOString();
    this.angularHostUrl = environment.infrastructure.googleCloud.angularHostUrl;

    // Generate PRINTABLE version. This points to an AEM id in the page itself.
    this.fetchApplicationAndAttach();
    this.fetchBeginApplicationPageAndAttach();
  }

  get isSEP(): boolean {
    return this.isSpecialEnrollment === 'true' ? true : false
  }

  setDisplayData() {
    let eApp: EnrollmentAppStateStructure = this.reducerUtilityService.getState('EnrollmentApp');

    if (!eApp.appId) {
      eApp = JSON.parse(sessionStorage?.getItem('confirmationBackup'));
    }

    this.eAppBackup = eApp;
    this.confirmationAppId = eApp.appId;
    this.submittedApplicantName = eApp.submittedApplicantName;
    this.effectiveDate = eApp.submittedEffectiveDate;

    // TODO: this is too explicit?
    const planState: PlansStateStructure = this.reducerUtilityService.getState('Plans');
    if (eApp.submittedPlan) {
      this.planName = eApp.submittedPlan.productName;
      this.planPremium = eApp.submittedPlan.price;
      this.ratingEntity = this.entityManagerService.getEntityInfoByEntityId(eApp.submittedPlan.attributes.RATING_ENTITY)?.entity.toUpperCase();
    } else if (planState.activeProductGroup === PRODUCT_GROUPS.WHOLE_HEALTH_BALANCE) {
      this.planName = 'Whole Health Balance';
    }

    this.configureIndividualConfirmation(eApp);

    if (!this.isAuthoring && !this.submittedApplicantName?.trim()) {
      const alertDuration = 5000; // ms

      this.snackBar.open(`Application Information is not present. If you recently submitted an application, please retrieve your information or reach out to customer support. Sending you back to the home page.`, 'OK', {
        duration: alertDuration,
        panelClass: 'negative-panel-class'
      });

      setTimeout(() => {
        window.location.assign(this.noEnrollmentDataUrl);
        return;
      }, alertDuration);
    }
  }

  configureIndividualConfirmation(eApp: EnrollmentAppStateStructure) {
    const payloadState = JSON.parse(JSON.stringify(this.reducerUtilityService.getPayloadStates()));
    let indPersonalInfo;
    if (payloadState.individualMarket?.ratingInfo?.subscriber[0]) {
      // TODO: move this to AEM config
      this.isIndividual = true;
      indPersonalInfo = payloadState.individualMarket.ratingInfo.subscriber[0];
      //this.submittedApplicantName = indPersonalInfo.firstName + ' ' + indPersonalInfo.lastName;
    }

    if (this.isIndividual) {
      // TODO: Move this to EBILL SSO component..
      this.showPayPremium = this.eAppBackup?.submittedPlan && indPersonalInfo.ssn;
      this.setIndividualEbillPayload(indPersonalInfo, eApp);
    }
  }

  async setIndividualEbillPayload(indPersonalInfo: any, eApp: any) {
    const zipcountyState: ZipCountyStateStructure = this.reducerUtilityService.getState('ZipCounty');

    let agencyId = '';
    let usrType = 'Member';

    if (this.commonUtilityService.isAgent()) {
      usrType = 'Agent';
      const selectedAgency = await this.entitlementsHelperService.getSelectedAgencyPromise();
      agencyId = selectedAgency?.agencyId;
    }

    // OFF is relevant for both DENTAL and OFF-EXCHANGE MEDICAL products
    const marketIdentifier = "OFF";


    this.payload = {
      baseMessage: {
        headerVersion: '1.0'
      },
      payload: {
        applicationId: eApp.appId,
        transactionID: '',
        paymentStatus: '',
        // TODO: submittedPlan is sometimes not avilable and crashing app?
        assignedQHPIdentifier: `${eApp.submittedPlan?.attributes?.BILL_MERCHANT_NAME}-${marketIdentifier}`,
        streetName1: indPersonalInfo.addressLine1,
        streetName2: indPersonalInfo.addressLine2,
        partnerAssignedConsumerID: indPersonalInfo.ssn,
        firstName: indPersonalInfo.firstName,
        middleName: indPersonalInfo.middleInitial,
        lastName: indPersonalInfo.lastName,
        paymentTransactionID: indPersonalInfo.ssn,
        additionalInformation: '',
        totalAmountOwned: eApp.submittedPlan?.price,
        premiumAmountTotal: eApp.submittedPlan?.price,
        aptcAmount: 0.0,
        cityName: indPersonalInfo.city,
        state: zipcountyState.county.state,
        zipCode: zipcountyState.zipCode,
        contactEmailAddress: indPersonalInfo.email,
        proposedCoverageEffectiveDate: this.effectiveDate,
        region: eApp.submittedPlan?.attributes.PLAN_REGION[0],
        preferredLanguageCode: 'EN',
        subscriberIdentifier: '', //subscriber.id,
        userType: usrType,
        agentID: agencyId,
        prospectID: ''
        // Fix this data whenver u figure it out from legacy
        // prospectID": (producerUser && producerUser.prospectData && producerUser.prospectData.payload && producerUser.prospectData.payload.prospect) ?
        //producerUser.prospectData.payload.prospect.prospectId : null
      }
    };
  }

  async ssoEbill() {
    const successObj: EBillTransferResponseInterface = await this.enrollSubmitIndividual.axwayEbillCall(this.payload);

    let ebillCookieKey = '';
    let payloadCookie = '';

    for (let i = 0; i < Object.keys(successObj.payload.cookieValues).length; i++) {
      if (Object.keys(successObj.payload.cookieValues)[i].includes('sp_ebill_cookie')) {
        ebillCookieKey = Object.keys(successObj.payload.cookieValues)[i];
        payloadCookie = successObj.payload.cookieValues[ebillCookieKey];
      }
    }

    const domain = window.location.hostname.split('.')[1];
    window.document.cookie = ebillCookieKey + '=' + payloadCookie + ';Domain=.' + domain + '.com;path=/;secure';
    window.open(successObj.payload.redirectURL, 'eBillWindow');
  }

  private fetchApplicationAndAttach() {

    /** 
     * Stored data is just rendered as text with whitespace
     */
     let stringifiedAppForm = this.commonUtilityService.base64decode(sessionStorage.getItem('applicationForm'));
    
     const _clean_up_app_text = (appForm: string): string => {
       return appForm
         .replace(/Edit/g, '____\n')
         .replace("\narrow_backBACK\nNEXTarrow_forward", '');
     } 

     const _generate_app_text_wrapper_node = (appForm: string): HTMLElement => {
       /**
        * Create a TEXT-APP-CONTAINER ( so we can maintain whitespace but not pollute the global scope )
        */
       const applicationNode = document.createTextNode(appForm);
       const containerElement: HTMLElement = document.createElement("div");
       containerElement.appendChild(applicationNode);
       containerElement.style.whiteSpace = 'pre-wrap';
       containerElement.style.breakBefore = 'page';
       containerElement.style.breakAfter = 'page';
 
       return containerElement;
     }
 
     /**
      * Attach TEXT-APP-CONTAINER to the actual page
      */
     const printApplicationNode = document.querySelector('.print-application-form');
     printApplicationNode.innerHTML = '';
     printApplicationNode.appendChild(_generate_app_text_wrapper_node(_clean_up_app_text(stringifiedAppForm)));
 
     // Below line only exists because my local can no longer support importing AEM changes to test 
     (printApplicationNode as HTMLElement).style.whiteSpace = 'normal';
     (printApplicationNode as HTMLElement).style.marginLeft = '0';
     (printApplicationNode as HTMLElement).style.marginRight = '0';
     (printApplicationNode as HTMLElement).style.width = '100%';
  }
  
  /**
   * Grab specific AEM page.html, strip it of headers/footers, DOMParser it, replace non-rendered data with data from enrollment obj,
   * give styling related to print-behavior
   */
  private async fetchBeginApplicationPageAndAttach() {

    const UNIQUE_ATTR = 'not-at-all-random-post-shadow-render-9f14d4fe-0b55-46c4-9d45-89bec5d6d786';
    const UNIQUE_TFOOT_CLASSNAME = 'confirmation-page-tfoot-1e42ec08-981c-4444-9fef-f0547f4db6ed';

    /** GET and Parse and HTML XHR */
    const _xhrRetrieval_and_domParse = async () => {
      
      const makeRequest = async(): Promise<string> => {
        
        /**
         * Fetch a page from AEM and pre-pend it to the print behavior
         */
        const requestConfig = new RequestConfigImplementation({
          method: REQUEST_METHODS.GET,
          url: `${this.beginAppPage?.replace(/\/$/,'')}.html`, // replace a trailing slash if it exists with nothing, then append .html
          responseType: 'text'
        });

        this.httpClient.setStrategy(XHR_STRATEGIES.DATAPOWER_MIDDLEWARE);
        this.httpClient.disableErrorSnackbar(requestConfig);

        return this.httpClient.makeRequest(requestConfig);
      }

      // Get it
      const html = await makeRequest();

      // Parse it
      const domParser = new DOMParser();
      return domParser.parseFromString(html, 'text/html');
    }

    /**
     * We'll use "between 2 experience fragments" to identify what we want ( the actual page content )
     */ 
    const _get_nonHeader_nonFooter_section = (doc: Document) => { 
      const expFragmentClass = 'core-dynamic-experience-fragment';

      // Query it
      const experienceFragmentElements = doc.getElementsByClassName(expFragmentClass);
  
      // Filter it
      let contentSection: HTMLElement = null;
      for (let i = 0; i < experienceFragmentElements.length; i++) {
  
        let currentExperienceFragment = experienceFragmentElements.item(i) as HTMLElement;
  
        /**
         * Below is a brief pseudo-structure that we're parsing at this point, and we want to get the content element:
         * 
         * <header/>
         * <content>we care about this</content>
         * <footer/>
         */
        // If the NEXT-next HTMLElement is ALSO an experience fragment ( it likely means we are looking @ the header and the next-next would be the footer )
        if (currentExperienceFragment?.nextElementSibling?.nextElementSibling?.classList.contains(expFragmentClass) ) {
  
          // Select it
          contentSection = currentExperienceFragment.nextElementSibling as HTMLElement;
  
          // Clean it up ( attempt to ignore LAYOUT view modifications: this is not beautiful )
          const parentSection = contentSection.getElementsByClassName('parent-width')[0];
          const pagePieces = parentSection.children[0].children[0].children as HTMLCollection;
          for (let j = 0; j < pagePieces.length; j++) {
            (pagePieces.item(j) as HTMLElement).style.marginLeft = '0';
            (pagePieces.item(j) as HTMLElement).style.marginRight = '0';
            (pagePieces.item(j) as HTMLElement).style.width = '100%';
          }
  
          return contentSection;
        }
      }
    }
    
    /**
     * Due to the possibility of there being OTHER sxe-app-state-as-content tags on the confirmation-page itself in the future:
     * Let's:
     * 1) identify those which are found ONLY in the page we're XHRing-in
     * 2) give them a pre-defined complex identifier ( for the sake of debugging via global search )
     * 
     * Later, we'll use this pre-defined identifier to swap in values that would otherwise not be available
     * ( as we clear the PLANS state, we'll snag the values from the plan on the ENROLLMENT (eApp) object )
     */
    const _tagToTrack_sxe_state_as_content = (content: HTMLElement) => {
      const appStateAsContentTags = content.getElementsByTagName('sxe-app-state-as-content');

      for (let i = 0; i < appStateAsContentTags.length; i++) {
        let currentAppStateAsContentTag = appStateAsContentTags.item(i) as HTMLElement;
        currentAppStateAsContentTag.setAttribute(UNIQUE_ATTR, i.toString());
      }
    }
    
    /**
     * Prepend this XHR'd HTML page
     */
    const _prepend_xhr_content_to_node = (content: HTMLElement) => {
      const finalHtml: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(content.outerHTML);
      const sanitizedFinalHtml = this.sanitizer.sanitize(SecurityContext.HTML, finalHtml);

      const element: HTMLElement = document.createElement("div")
      element.classList.add('begin-app-content');
      element.style.breakBefore = 'page';
      element.style.breakInside = 'avoid'; // without this, for some reason, remote didn't respawn the breakBefore
      element.innerHTML = sanitizedFinalHtml;
      
      const printApplicationNode = document.querySelector('.print-application-form');
      printApplicationNode.prepend(element);
    }
    
    /**
     * Replace previously identified SXE-APP-STATE-AS-CONTENT content with those captured above
     */
    const _replace_sxe_state_as_content = () => {

      let enrollmentAppStateStructure: EnrollmentAppStateStructure = this.reducerUtilityService.getState('EnrollmentApp');
      const appStateAsContentTagsWithShadowDom = document.getElementsByTagName('sxe-app-state-as-content');

      for (let i = 0; i < appStateAsContentTagsWithShadowDom.length; i++) {
        if (appStateAsContentTagsWithShadowDom.item(i).attributes[UNIQUE_ATTR]) {
          let header = appStateAsContentTagsWithShadowDom.item(i).shadowRoot.querySelector('h2');
  
          switch (appStateAsContentTagsWithShadowDom.item(i).attributes['app-state-as-content'].value) {
            case APP_STATE_AS_CONTENT_ENUM.PLAN_NAME:
              header.innerHTML = enrollmentAppStateStructure.submittedPlan.productName?.toString();
              break;
            case APP_STATE_AS_CONTENT_ENUM.PLAN_PRICE:
              header.innerHTML = this.currencyPipe.transform(enrollmentAppStateStructure.submittedPlan.price?.toString());
              break;
            case APP_STATE_AS_CONTENT_ENUM.PLAN_RATING_ENTITY:
              header.innerHTML = this.entityManagerService.getEntityInfoByEntityId(enrollmentAppStateStructure.submittedPlan.attributes.RATING_ENTITY)?.entity.toUpperCase();
              break;
            default:
              break;
          }
        }
      }
    }
    
    /**
     * This creates TWO tfoot elements ( note: convention only allows you to have 1, and yet.... ) to solve the:
     * (1) overlapping content/footer, and
     * (2) lack of bottom-of-FINAL-page footer
     * 
     * We create two because they each serve a separate purpose:
     * (1) a "hidden" element ( with white text ) which does not use the "fixed" display
     * (2) a "visible" element ( with non-white text ) which uses the "fixed" display
     * 
     * What this does:
     * (1) content will not bleed over the footer, and will give it space to live, and
     * (2) the final page will have its footer present on the bottom of its page, instead of just the "end" of the "table"
     * 
     */
    const _create_and_attach_tfoot = () => {

      const createFooterElementBase = (): HTMLElement => {
        
        // Populate Footer Values for Form Number
        const element = document.createElement("tfoot");
        element.style.bottom = '0';
        element.classList.add(UNIQUE_TFOOT_CLASSNAME);

        const individualMarketState: IndividualMarketStateStructure = this.reducerUtilityService.getPayloadStates()?.individualMarket;
        let isChildOnly = false;
        try {
          isChildOnly = individualMarketState?.childOnlyPolicy && individualMarketState?.childOnlyPolicy.toUpperCase() === 'YES';
        } catch (e) {
          isChildOnly = individualMarketState?.childOnlyPolicy as unknown as boolean;
        }

        const formNumber = this.formNumberService.generateFormNumber(this.isSEP, isChildOnly);
        if (formNumber) {
          element.innerHTML = `${formNumber}`;
        }
        
        return element;
      }

      // Populate Footer Values for Form Number
      const footerElement1 = createFooterElementBase();
      footerElement1.style.color = 'white';

      const footerElement2 = createFooterElementBase();
      footerElement2.style.position = 'fixed';
      
      document.getElementsByTagName('body')[0].appendChild(footerElement1);
      document.getElementsByTagName('body')[0].appendChild(footerElement2);
    }
    
    try {
      let xhrDoc = await _xhrRetrieval_and_domParse();
      if (xhrDoc) {
        const neededSection = _get_nonHeader_nonFooter_section(xhrDoc);
        _tagToTrack_sxe_state_as_content(neededSection);
        _prepend_xhr_content_to_node(neededSection);
        _replace_sxe_state_as_content();
      }
    } catch (e) {
      console.error(`Failed to retrieve page @ ${this.beginAppPage}`, e);
    }

    if (this.lineOfBusiness === LINE_OF_BUSINESS_ENUM.INDIVIDUAL) {
      _create_and_attach_tfoot();
    }

    /** 
     * Add event handlers to observe when we are going into print-mode, and update styling to support this
     * ( We change our <body> tag to present as a 'table' in order to apply a 'tfoot', which will exist on every page )
     */
    (() => {

      let beforePrint = () => {
        // console.log('Functionality to run before printing.');
        document.getElementsByTagName('body')[0].style.display = 'table';
        const tfootElements = document.getElementsByClassName(UNIQUE_TFOOT_CLASSNAME);
        for (let i = 0; i < tfootElements.length; i++) {
          (tfootElements.item(i) as HTMLElement).style.display = 'table-footer-group';
        }
      };

      let afterPrint = () => {
        // console.log('Functionality to run after printing');
        document.getElementsByTagName('body')[0].style.display = 'block';
        const tfootElements = document.getElementsByClassName(UNIQUE_TFOOT_CLASSNAME);
        for (let i = 0; i < tfootElements.length; i++) {
          (tfootElements.item(i) as HTMLElement).style.display = 'none';
        }
      };
    
      if (window.matchMedia) {
        const mediaQueryList: MediaQueryList = window.matchMedia('print');
        mediaQueryList.onchange = ((mql) => {
          if (mql.matches) {
            beforePrint();
          } else {
            afterPrint();
          }
        });
      }
    
      window.onbeforeprint = beforePrint;
      window.onafterprint = afterPrint;
      afterPrint();

    })();
  }

}
